/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetProfileModel } from './PetProfileModel';
import {
    PetProfileModelFromJSON,
    PetProfileModelFromJSONTyped,
    PetProfileModelToJSON,
} from './PetProfileModel';

/**
 * 
 * @export
 * @interface PetProfileResultsModel
 */
export interface PetProfileResultsModel {
    /**
     * 
     * @type {number}
     * @memberof PetProfileResultsModel
     */
    start: number;
    /**
     * 
     * @type {number}
     * @memberof PetProfileResultsModel
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PetProfileResultsModel
     */
    total: number;
    /**
     * 
     * @type {Array<PetProfileModel>}
     * @memberof PetProfileResultsModel
     */
    results: Array<PetProfileModel>;
}

/**
 * Check if a given object implements the PetProfileResultsModel interface.
 */
export function instanceOfPetProfileResultsModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PetProfileResultsModelFromJSON(json: any): PetProfileResultsModel {
    return PetProfileResultsModelFromJSONTyped(json, false);
}

export function PetProfileResultsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetProfileResultsModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': json['start'],
        'limit': json['limit'],
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(PetProfileModelFromJSON)),
    };
}

export function PetProfileResultsModelToJSON(value?: PetProfileResultsModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start,
        'limit': value.limit,
        'total': value.total,
        'results': ((value.results as Array<any>).map(PetProfileModelToJSON)),
    };
}

